export const SET_SHOW = "TOAST/SET_SHOW"
export const SET_MESSAGE = "TOAST/SET_MESSAGE"
export const SET_TIMER = "TOAST/SET_TIMER"
export const SET_ICON = "TOAST/SET_ICON"
export const SET_THEME = "TOAST/SET_THEME"
export const SET_SHOW_TOAST_CONFIRM = "TOAST/SET_SHOW_TOAST_CONFIRM"
export const SET_CALLBACK_TOAST = "TOAST/SET_CALLBACK_TOAST"
